import Vue from 'vue';
import campanyInfoImport from './company-info-import.vue';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'inforMsg',
    components: {
        campanyInfoImport: campanyInfoImport,
    },
    props: {
        // 公司类型
        type: {
            type: String,
            default: '',
            required: true,
        },
        // 公司类型（按钮上）
        importBtnName: {
            type: String,
            default: '',
            required: true,
        },
        //公司类型code
        cityType: {
            type: String,
            default: '',
            required: true,
        },
    },
    computed: {
        dataList: function () {
            var datas = this.campanyData.cityCompanyMap;
            var arr = [];
            var compare = function (a, b) {
                if (a['sort'] < b['sort']) {
                    return 1;
                }
                else if (a['sort'] > b['sort']) {
                    return -1;
                }
                else {
                    return 0;
                }
            };
            this.companySum = this.campanyData.companySum;
            for (var item in datas) {
                if (Array.isArray(datas[item])) {
                    arr.push(datas[item]);
                }
            }
            arr.sort(compare);
            return arr;
        },
    },
    data: function () {
        return {
            campanyData: {},
            dialogCampany: false,
            companySum: 0,
            usernameZh: '',
            isHover: false,
        };
    },
    created: function () {
        this.getUserName();
        this.getCompangList();
        // this.getCityList()
    },
    methods: {
        getCompangList: function (code, pageNo) {
            var _this = this;
            var type = this.cityType;
            var url = "/proxy/api/company/city/cityAlphaGroup";
            var data = {
                type: type === 'SIGN' ? 1 : type === 'SETTLEMENT' ? 2 : '',
                operator: this.usernameZh,
            };
            this.$request({
                method: 'post',
                url: url,
                data: data,
            }).then(function (res) {
                if (!res.errorCode) {
                    _this.campanyData = res.data;
                }
            });
        },
        importCampany: function () {
            this.dialogCampany = true;
        },
        shutDiglog: function () {
            this.getCompangList();
            this.dialogCampany = false;
            // this.getCityList()
        },
        overStatus: function () {
            this.isHover = true;
        },
        outStatus: function () {
            this.isHover = false;
        },
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
    },
});
